import useApiClient from "../../useApiClient";
import { useSelector } from "react-redux";
import { useCallback } from "react";
import { withNetworkErrorHandling } from "../../helpers/withNetworkErrorHandling";

const useRecurringTasksAPIClient = () => {
  const { get, update, remove } = useApiClient();
  const { activeUser } = useSelector((state) => state.user);

  const getRecurringTasks = useCallback(async () => {
    const response = await withNetworkErrorHandling(() =>
      get(`users/${activeUser.userId}/recurringTasks`),
    );
    return response?.message;
  }, [activeUser, get]);

  const setTaskRecurringFrequency = useCallback(
    async (taskId, patches) => {
      const response = await withNetworkErrorHandling(() =>
        update(`users/${activeUser.userId}/recurringTasks/${taskId}`, patches),
      );
      return response?.message;
    },
    [activeUser, update],
  );

  const removeTaskFrequency = useCallback(
    async (taskId) => {
      return await withNetworkErrorHandling(() =>
        remove(`users/${activeUser.userId}/recurringTasks/${taskId}`),
      );
    },
    [activeUser, remove],
  );

  return { getRecurringTasks, setTaskRecurringFrequency, removeTaskFrequency };
};

export default useRecurringTasksAPIClient;
